import { styled, Button, Snackbar, Alert } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const SettingsActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 500,
  padding: theme.spacing(1, 2),
  borderRadius: '8px',
}));

export const SettingsPrimaryButton = styled(SettingsActionButton)(({ theme }) => ({
  boxShadow: 'none',
  background: theme.gradients.primaryCta,
  color: theme.palette.common.white,
  '&:hover': {
    background: theme.gradients.primaryCtaHover,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
  },
}));

export const SettingsSecondaryToolbarButton = styled(SettingsActionButton)(({ theme }) => ({
  borderColor: theme.palette.divider,
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.background.paper,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.primary,
    borderColor: theme.palette.divider,
  },
}));

export const SettingsDangerToolbarButton = styled(SettingsActionButton)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.error.main,
  borderColor: theme.palette.error.main,
  '&:hover': {
    backgroundColor: alpha(theme.palette.error.main, 0.12),
    borderColor: theme.palette.error.dark,
    color: theme.palette.error.light,
  },
  '&:disabled': {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.action.disabled,
    borderColor: theme.palette.divider,
  },
}));

export const StyledSettingsSnackbar = styled(Snackbar)(() => ({
  '& .MuiSnackbarContent-root': {
    borderRadius: '8px',
  },
}));

export const StyledSettingsAlert = styled(Alert)(() => ({
  borderRadius: '8px',
  '& .MuiAlert-message': {
    fontSize: '0.875rem',
  },
}));
